import { render, staticRenderFns } from "./EvaluationRecruitmentMeasurePage.vue?vue&type=template&id=520bf284&"
import script from "./EvaluationRecruitmentMeasurePage.vue?vue&type=script&lang=js&"
export * from "./EvaluationRecruitmentMeasurePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports